import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { approverApi } from 'src/app/config/api-url';

@Injectable({
  providedIn: 'root'
})
export class ApproverService {

  constructor(private apiService: ApiService) {}
  
  getActivityList(){
    return this.apiService.get(`${approverApi.getActivityList}`)
  }
  getactivityGridData(req){
    return this.apiService.get(`${approverApi.getActivityGridData}${req}`)
  }
  updateStatus(req){
    return this.apiService.post(`${approverApi.approverUpdateStatus}${req}`)
  }
  getApprovalCount(req){
    return this.apiService.get(`${approverApi.getApprovalCount}${req}`)
  }
  getApprovalListBySearch(req){
    return this.apiService.get(`${approverApi.getApproverlistBySearch}${req}`)
  }
}
